import { useNewVersionPrompt } from "../common/hooks/useNewVersionPrompt";
import VersionUpdateDialog from "./dialogs/VersionUpdateDialog";

const VersionWatcher = () => {

    const { updateInfo, isFirstView, reload } = useNewVersionPrompt(5000);

    if (!updateInfo) return null;
    return (
        <VersionUpdateDialog updateInfo={updateInfo} reload={reload} isFirstView={isFirstView} />
    )
}

export default VersionWatcher;